<template>
  <!-- row w-100 justify-content-center align-items-center m-auto pt-3 z-index-99 -->
  <div class="hero-slider container-fluid px-0 m-0 w-100 h-100">
    <vue-agile ref="heroSlider" :options="vueAgileOptions" v-if="images && images.length > 0">
      <div v-for="(item, index) in images" :key="`slide-item-${index}`" class="slide">
        <div class="image" :style="{backgroundImage: `url(${item})`}" />
      </div>
    </vue-agile>
    <div class="black-overlay"></div>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import { mapGetters } from 'vuex'

export default {
  name: 'HeroSlider',

  components: {
    VueAgile
  },

  data() {
    return {
      vueAgileOptions: {
        pauseOnHover: false,
        autoplaySpeed: '6000',
        speed: '1000',
        dots: false,
        slidesToShow: '1',
        autoplay: true,
        fade: true
      }
    }
  },
  mounted() {

  },
  computed: {
    images() {
      if ((/^((?!chrome|android).)*safari/i.test(navigator.userAgent))) {
        return this.$store.getters.slidesIOS
      } else {
        return this.$store.getters.slides
      }
    },
    ...mapGetters({
      loadingState: 'loadingState'
    })
  },
  methods: {
   shuffle(array) {
     var currentIndex = array.length, temporaryValue, randomIndex;
     // While there remain elements to shuffle...
     while (0 !== currentIndex) {
       // Pick a remaining element...
       randomIndex = Math.floor(Math.random() * currentIndex);
       currentIndex -= 1;
       // And swap it with the current element.
       temporaryValue = array[currentIndex];
       array[currentIndex] = array[randomIndex];
       array[randomIndex] = temporaryValue;
     }
     return array;
   }
  },
  watch: {
   loadingState(newVal) {
    if(!newVal) this.$refs.heroSlider.restartAutoPlay()
   }
  }
}
</script>

<style scoped>
.hero-slider {
  background: black;
  overflow-y: hidden;
}
.image {
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  opacity: 0.7;
}
.black-overlay {
 position: absolute;
 width: 100%;
 height: 100%;
 top: 0;
 left: 0;
 background-color: rgb(0,0,0,0.3);
}
</style>
